<template>
  <div class="step step_0" :class="{ 'form__step_hidden': step != number }" :aria-labelledby="`step${number}-title`">
    <transition-group tag="div" name="fade" class="transitiongroup" ref="transitiongroup">
      <RadioGroup :vertical="true" :key="12345" :attrmode="true" v-model="stepsdata[number][names[0]]" :grid="true" :gridstay="true" :name="names[0]" title="Основной заёмщик уже заполнил форму?" :required="true" :values="['Да', 'Нет']" />
      <transition-group :key="12346" :style="{ 'height': (stepsdata[number][names[0]] != 'Да') ? '0px !important' : '' }" tag="div" name="fade" class="switchwrap">
        <TextInput v-show="stepsdata[number][names[0]] == 'Да'" :key="102" v-model="stepsdata[number][names[1]]" :name="names[1]" :increased="!stepsdata[number][names[1]]" text="Укажите ФИО основного заёмщика" />
      </transition-group>
    </transition-group>
    <div class="form__btns">
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'
import smoothReflow from 'vue-smooth-reflow'
import TextInput from './TextInput.vue'

export default {
  data: () => ({
    names: ['main_borrower_finished', 'main_borrower_FIO'],
    errorcont: {},
  }),
  components: { Btn, RadioGroup, TextInput },
  props: {
    number: { type: Number, default: 0 }
  },
  mixins: [smoothReflow],
  mounted() {
    this.$smoothReflow({
      el: this.$refs.transitiongroup.$el,
      transition: 'height .5s'
    })
    for (let el of this.$el.querySelectorAll('.switchwrap'))
      this.$smoothReflow({ el, transition: 'height .5s' })

  },
  methods: {
    filled() {
      for (let name of this.activeFields)
        if (!this.stepsdata[this.number][name] || this.errorcont[name])
          return false
      return true
    }
  },
  computed: {
    ...mapState(['stepsdata', 'step']),
    activeFields() {
      let r = this.names.map(el => el)
      if (this.stepsdata[this.number][this.names[0]] != 'Да')
        r.pop()
      return r
    },
  },
}
</script>

<style lang="sass">
</style>